import { useEffect, useRef, useState } from 'react';
import { GlobalWorkerOptions, getDocument, RenderTask } from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';

GlobalWorkerOptions.workerSrc = pdfjsWorker;

function S3PdfPreview({ pdfUrl }: { pdfUrl: string }) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [imageData, setImageData] = useState<string | null>(null);
  let renderTask: RenderTask | null = null;
  let isRendering = false;

  const renderPDF = async () => {
	if (isRendering) {
		// console.warn('Render already in progress. Skipping.');
		return;
	}

	isRendering = true;

	try {
		const pdf = await getDocument(pdfUrl).promise;
		const page = await pdf.getPage(1);
		const viewport = page.getViewport({ scale: 2 });

		const canvas = canvasRef.current;
		if (!canvas) return;

		const context = canvas.getContext('2d');
		if (!context) return;

		canvas.height = viewport.height;
		canvas.width = viewport.width;

		if (renderTask) {
			try {
				renderTask.cancel();
			} catch (e) {
				// Already cancelled or completed
			}
		}

		renderTask = page.render({
		canvasContext: context,
		viewport,
		});

		await renderTask.promise;

		const imageUrl = canvas.toDataURL();
		setImageData(imageUrl);
	} catch (err) {
		console.error('Failed to render PDF:', err);
	} finally {
		isRendering = false;
		renderTask = null;
	}
  };

  useEffect(() => {
	renderPDF()
  }, [pdfUrl]);

  return (
    <div>
      {imageData ? (
        <img src={imageData} alt="PDF preview" className='max-w-full max-h-40 m-auto' />
      ) : (
        <a rel="noreferrer" href={pdfUrl} target='_blank' className='flex w-full h-full'>
			<img alt='pdf' className='m-auto' src='/images/pdf.png' />
		</a>
      )}
      <canvas ref={canvasRef} className='hidden' />
    </div>
  );
}

export default S3PdfPreview;
